import mutations from './drugBno.mutations'
import actions from './drugBno.actions'
import getters from './drugBno.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
